__webpack_require__.p = "https://ikea.marat.qd.je/ch/fr/customer-service/support/";